import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ModuleAccessError from '../components/ModuleAccessError';

const ModuleAccessErrorPage: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    // Get error from localStorage or event
    const storedError = localStorage.getItem('moduleAccessError');
    if (storedError) {
      try {
        setError(JSON.parse(storedError));
      } catch (e) {
        console.error('Failed to parse module access error:', e);
      }
    }

    // Listen for module access errors
    const handleModuleAccessError = (event: CustomEvent) => {
      setError(event.detail);
    };

    window.addEventListener('moduleAccessError', handleModuleAccessError as EventListener);

    return () => {
      window.removeEventListener('moduleAccessError', handleModuleAccessError as EventListener);
    };
  }, []);

  if (!error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Page Not Found</h1>
          <p className="text-gray-600 mb-6">The page you're looking for doesn't exist.</p>
          <button
            onClick={() => navigate('/admin/dashboard')}
            className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <ModuleAccessError
      error={error}
    />
  );
};

export default ModuleAccessErrorPage;
